import {
  FilterMode,
  AuthorComposerCreateMutationVariables,
  AuthorComposer_OrderBy,
  AuthorComposer,
  SortOrder,
  AuthorComposer_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const authorComposerService = {
  createOne: buildCreateOne(
    (authorComposerCreateVariables: AuthorComposerCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.authorComposerCreate(
          authorComposerCreateVariables
        );
        return result.authorComposerCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.authorComposerOne({ id });
    return result.authorComposerOne as AuthorComposer;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AuthorComposer_OrderBy[] | null = null,
    filter: AuthorComposer_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AuthorComposer_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          {
            firstName: { contains: searchValue, mode: FilterMode.Insensitive },
          },
          { lastName: { contains: searchValue, mode: FilterMode.Insensitive } },
          { aka: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.authorComposerListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [
            { firstName: SortOrder.Asc },
            { lastName: SortOrder.Asc },
            { aka: SortOrder.Asc },
          ],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.authorComposerListWithOffset
    ) as AuthorComposer[];
    return { list, orderBy };
  },
};
